import { resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];

  static getDefaultData = (): WidgetProps => {
    return {
      headerText: 'Se pris och köp din olycksfallsförsäkring',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprInvalidMessage: 'Vänligen kontrollera personnumret.',
      minAgeErrorText:
        'För dig som är under 18 år, kontakta kundservice så hjälper vi dig.',
      maxAgeErrorText:
        'Du måste vara under 74 år för att kunna köpa den här försäkringen.',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      calculateBtnLabel: 'Se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: {
        image: 'SunKissedMan_simple.png',
        smallScreenImage: 'SunKissedManSmallScreen_simple.png',
        imageAltText: ''
      }
    };
  };

  static getEnonicContent = async (dataUrl: string, dataObject: any) => {
    let enonicData = {};
    if (dataObject) {
      try {
        enonicData = JSON.parse(dataObject);
      } catch {
        return enonicData;
      }
    } else {
      const response: any = await apiFetcher.postJson(dataUrl);
      if (response.isOk()) {
        if (response.value) {
          enonicData = response.value;
        }
      }
    }
    return enonicData;
  };
  static getImageCDNPath = (fileName: string) =>
    `${resolveCDNDir()}images/${fileName}`;

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    return {
      headerText: additionalData?.headerText || defaultData.headerText,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      cprInvalidMessage:
        additionalData?.cprInvalidMessage || defaultData.cprInvalidMessage,
      minAgeErrorText:
        additionalData?.minAgeErrorText || defaultData.minAgeErrorText,
      maxAgeErrorText:
        additionalData?.maxAgeErrorText || defaultData.maxAgeErrorText,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: additionalData?.imageFileName || defaultData?.imageInfo?.image,
        smallScreenImage:
          additionalData?.smallScreenImageFileName ||
          defaultData?.imageInfo?.smallScreenImage,
        imageAltText: additionalData?.imageAltText || ''
      }
    };
  };
}
